import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import React from 'react';
import {useRouter} from 'next/router'
import {trackPage} from "../../tracking/index";
import Config from '../../config';
import {getStaticPath} from '../../utils';
import ReportList from '../../components/investors/ReportList';
import { getPageViewData } from '../../utils/tracking';
import page_data from '../../data/page_data';



const Fetcher = async () => {
  
  const data = {
    meta_tag_data: page_data["investor-report"]?.meta_tag || [],
    pageName: 'annual-returns'
  }

  return data
}

export async function getServerSideProps() {

  const data = await Fetcher()

  return {
    props: data
  }

}


export default function Home(props) {
  const router = useRouter()
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath("/static/images/why-onsitego.svg")

  React.useEffect(()=>{
    trackPage("Annual Returns",{...getPageViewData()})
},[props])

  let cached_props:any = props || {}

  return (
    <>
      <Head>
        <title>Annual Returns</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content={cached_props?.meta_tag_data?.tag_description}></meta>
        <meta property="og:title" content="Onsitego | Annual Returns "/>
        <meta property="og:description" content=""/>
        <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
        <meta property="og:image" content={OG_IMAGE}/>
        <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
      </Head>
      <PlainBanner title="Annual Returns">
      </PlainBanner>
      <ReportList />
    </>
  )
}